import type { SVGProps } from "react";
export interface TankTopNumberIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TankTopNumberIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TankTopNumberIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.258 10.876c.593.038 1.055.53 1.055 1.124v4.875h.562l.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H10.5a1.125 1.125 0 0 1 0-2.25h.563v-2.282q-.07.012-.141.02l-.246.012H10.5a1.125 1.125 0 0 1 0-2.25h.176l.069-.006a.38.38 0 0 0 .303-.322l.023-.186a1.126 1.126 0 0 1 1.187-.985"
      />
      <path
        fill={color}
        d="m15.875 3.59-.437 2.623a3.486 3.486 0 0 1-6.877 0L8.125 3.59v3.408c0 1.197-.302 2.17-.813 2.938a4.5 4.5 0 0 1-1.187 1.198V20c0 .483.391.874.875.875h10a.874.874 0 0 0 .875-.875v-8.865a4.5 4.5 0 0 1-1.186-1.198c-.511-.768-.814-1.74-.814-2.938V3.591ZM18.125 7c0 .803.198 1.33.436 1.688.244.365.576.623.942.806.381.19.622.58.622 1.007V20A3.124 3.124 0 0 1 17 23.125H7A3.125 3.125 0 0 1 3.875 20v-9.5c0-.426.241-.815.623-1.006a2.4 2.4 0 0 0 .941-.806c.239-.357.436-.886.436-1.689V2.666c0-.483.31-.913.769-1.066l2-.668.12-.032a1.126 1.126 0 0 1 1.345.915l.671 4.027.057.216a1.236 1.236 0 0 0 2.382-.216l.671-4.027.026-.12a1.127 1.127 0 0 1 1.44-.763l2 .668c.46.153.769.582.769 1.066z"
      />
    </svg>
  );
}
